var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconEraseDownOut = function SvgIconEraseDownOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    x: 1,
    y: 1,
    fill: "#D9D9D9",
    stroke: "#fff",
    strokeWidth: 2,
    rx: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#222",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 12v6M14 16l-2 2-2-2M5 8.111v2.778C5 11.503 5.482 12 6.077 12h11.846c.595 0 1.077-.498 1.077-1.111V8.11C19 7.497 18.518 7 17.923 7H6.077C5.482 7 5 7.497 5 8.111"
  })));
};
export default SvgIconEraseDownOut;